// modules/CodebookRoutes.ts
import { RouteRecordRaw } from 'vue-router';

const CodebookRoutes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    component: () => import('@/views/HomeView.vue'),
    name: 'home',
    meta: { title: '首页', icon: 'icon'}
  },
  {
    path: '/codebook',
    component: () => import('@/views/codebook/CodebookView.vue'),
    name: 'codebook',
    meta: { title: '密码本', icon: 'icon'}
  },
  {
    path: '/logger',
    component: () => import('@/views/codebook/LoggerView.vue'),
    name: 'logger',
    meta: { title: '日志管理', icon: 'icon'}
  },
  {
    path: '/security',
    component: () => import('@/views/codebook/SecurityView.vue'),
    name: 'security',
    meta: { title: '安全管理', icon: 'icon'}
  },
  {
    path: '/file',
    component: () => import('@/views/codebook/FileView.vue'),
    name: 'file',
    meta: { title: '内容存储', icon: 'icon'}
  }
];

export default CodebookRoutes;
